import type { FC } from "react";
import { getNumberFormat } from "../../../utils/numberFormat";
import { usePlanePoint, type PlanePointStore } from "./planePointStore";
import styles from "./PlaneCoordinatesReadout.module.css";

type PlaneCoordinatesReadoutProps = {
  pointStore: PlanePointStore;
};

const formatCoordinate = (value: number): string => {
  const absoluteValue = Math.abs(value);

  if (absoluteValue >= 1000000) {
    return value.toExponential(1);
  }

  const fractionDigits = absoluteValue >= 10000 ? 0 : 2;

  return getNumberFormat(undefined, {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  }).format(value);
};

// The hover point's x/y, subscribed on its own so the pointer moving only re-renders this readout.
const PlaneCoordinatesReadout: FC<PlaneCoordinatesReadoutProps> = ({ pointStore }) => {
  const point = usePlanePoint(pointStore);

  return (
    <div className={styles.coordinates}>
      <span>x: {point ? formatCoordinate(point.x) : "0.00"}</span>
      <span>y: {point ? formatCoordinate(point.y) : "0.00"}</span>
    </div>
  );
};

export default PlaneCoordinatesReadout;
